<template>
    <amf-search-box @select="onSelectUser" 
        :label="label" 
        :placehold="'Search users'"
        :search="internalSearch"
        :autofocus="autofocus"
        :showResultAfterSelection="showResultAfterSelection"
        :showClearButton="showClearButton"
        @clear="onClearUser"
         >
    </amf-search-box>
</template>

<script>
    export default {
        props: {
            search: {
                type: Function
            },
            onSelectUser: {
                type: Function,
                required: true
            },
            onClearUser: {
                type: Function,
                default: () => {}
            },
            label: {
                type: String,
                default: "Search Users"
            },
            autofocus: {
                type: Boolean,
                default: false
            },
            showResultAfterSelection: {
                type: Boolean,
                default: false
            },
            showClearButton: {
                type: Boolean,
                default: false
            },
            searchType: {
                type: String,
                default: "forActionItems"
            }
        },
        data() {
            return {
            }
        },
        methods: {
            async internalSearch(text) {
                if (this.search) {
                    return this.search(text);
                }

                if (this.searchType == "forActionItems") {
                    return await this.searchUsersForActionItems(text);
                } else if (this.searchType == "impersonated") {
                    return await this.searchImpersonationCandidates(text);
                }
            },
            async searchUsersForActionItems(text) {
                let result = await romeApi.get("actionitem/v-2/eligibleusers", { searchText: text }); 
                return result.map(r => {
                    let userText = `${r.firstName} ${r.lastName} <${r.userName}>`;
                    return {
                        ...r,
                        id: r.userId,
                        icon: "fa-user",
                        title:  userText
                    };
                });
            },
            async searchImpersonationCandidates(text) {
                var result = await romeApi.get("user/impersonation/candidates", { searchText: text });
                return result.map(r => { 
                    var userText = `${r.firstName} ${r.lastName} <${r.userName}>`;
                    return {
                        ...r,
                        id: r.userId, 
                        icon: "fa-user", 
                        title: r.employerName 
                                ? `${userText} - ${r.employerName}`
                                : userText
                    };
                });
            }
        }
    }

</script>

<style lang="scss" scoped>
</style>




// WEBPACK FOOTER //
// src/shared/UserSearch.vue